/** Short, scaled laptop displays; deliberately excludes mobile and roomy desktops. */
export const COMPACT_DESKTOP_QUERY =
  "(min-width: 1200px) and (max-width: 1399.95px) and (max-height: 760px)";
export const COMPACT_SIDEBAR_WIDTH = 184;
